module.exports = __webpack_public_path__ + "static/media/Thaniya.dd41e603.png";